import React from 'react'
import FramedIcon from 'redesign/components/atoms/FramedIcon'
import { DocumentPDF } from 'redesign/components/atoms/Icon'
import { useDocument } from 'redesign/components/templates/ContentLists/Documents/useDocument'
import ContentCard from '../content-card'
import { TimelineItemContainer } from '../timeline-item/styles'
import type { TimelineDocumentProps } from './types'

const TimelineDocument: React.FC<TimelineDocumentProps> = ({ document, openMonthlySheetDialog }) => {
  const { documentLabel, contentData, displaying, displayFileCallback } = useDocument({
    document,
    openMonthlySheetDialog,
  })
  const { subtitle } = contentData

  return (
    <TimelineItemContainer data-testid="timeline-document">
      <ContentCard
        header={{
          icon: <FramedIcon icon={DocumentPDF} />,
          title: documentLabel,
          titleTestId: 'timeline-document-title',
          subtitle,
          subtitleTestId: 'timeline-document-subtitle',
          showChevron: true,
        }}
        onClick={() => {
          !displaying && displayFileCallback()
        }}
      />
    </TimelineItemContainer>
  )
}

export default TimelineDocument
